import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { complianceService } from '../services/adminService';

const DSRRequest: React.FC = () => {
  const [email, setEmail] = useState('');
  const [subjectType, setSubjectType] = useState<'affiliate' | 'customer'>('customer');
  const [type, setType] = useState<'access' | 'deletion' | 'rectification'>('access');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error('Please enter a valid email');
      return;
    }
    setSubmitting(true);
    try {
      await complianceService.submitDSR({ subject_type: subjectType, type, email });
      toast.success('Request submitted. We\'ll email you updates.');
      setEmail('');
      setType('access');
      setSubjectType('customer');
    } catch (e: any) {
      toast.error(e?.message || 'Failed to submit request');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto space-y-6">
      <h1 className="text-2xl font-semibold">Data Subject Request</h1>
      <p className="text-sm text-gray-600">Submit a request to access, export, rectify, or erase your data.</p>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium">Email</label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full border rounded px-3 py-2"
            placeholder="you@example.com"
          />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div>
            <label htmlFor="subjectType" className="block text-sm font-medium">Subject Type</label>
            <select id="subjectType" aria-label="Subject Type" value={subjectType} onChange={(e) => setSubjectType(e.target.value as 'affiliate' | 'customer')} className="mt-1 w-full border rounded px-3 py-2">
              <option value="customer">Customer</option>
              <option value="affiliate">Affiliate</option>
            </select>
          </div>
          <div>
            <label htmlFor="requestType" className="block text-sm font-medium">Request Type</label>
            <select id="requestType" aria-label="Request Type" value={type} onChange={(e) => setType(e.target.value as 'access' | 'deletion' | 'rectification')} className="mt-1 w-full border rounded px-3 py-2">
              <option value="access">Access</option>
              <option value="rectification">Rectification</option>
              <option value="deletion">Deletion</option>
            </select>
          </div>
        </div>

        <button type="submit" disabled={submitting} className="px-4 py-2 rounded bg-indigo-600 text-white disabled:opacity-50">
          {submitting ? 'Submitting...' : 'Submit Request'}
        </button>
      </form>

      <p className="text-xs text-gray-500">
        By submitting, you consent to us using your email to process your request and provide updates.
      </p>
    </div>
  );
};

export default DSRRequest;
